import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';
import GoogleMapReact from 'google-map-react';
import { Link } from 'react-router';
import 'whatwg-fetch';
import InfoButton from "./InfoButton";

class StoresOnMapViewer extends Component {
    static defaultProps = {
        center: {lat: 60.19, lng: 24.94},
        zoom: 6,
        apiKey: "AIzaSyCu1HfWSW93GZt5Ru7yANrEa-rOa6HgVSE"
    };

    constructor(props) {
        super(props);
        this.state = {
            stores: [],
            center: props.center,
            zoom: props.zoom,
            loadingOwnLocation: false
        };
        this.centerToStore = this.centerToStore.bind(this);
        this.updateStoreData = this.updateStoreData.bind(this);
        this.showPosition = this.showPosition.bind(this);
    }

    updateStoreData(stores) {
        this.setState(() =>  {
            return {stores: stores};
        });
    }

    componentDidMount() {
        this.props.dataLoader.loadStores().then(stores => this.updateStoreData(stores))
    }

    centerToStore(store, e, alwaysShowInfo) {
        e.preventDefault();
        store.showInfo = !store.showInfo || alwaysShowInfo;
        this.setState(() =>  {
            return {center: store.location, zoom: 16};
        });
    }

    getLocation() {
      if (navigator.geolocation) {
        this.setState({
          loadingOwnLocation: true
        });
        navigator.geolocation.getCurrentPosition(this.showPosition, () =>  {
          alert("Paikannus ei sallittu");
          this.setState({
            loadingOwnLocation: false
          });
        });
      }
    }

    showPosition(position) {
      let closest = {store: {}, distance: 999};
      this.state.stores.forEach((store, i) => {
          if (store.location){
            let x = Math.pow(store.location.lat - position.coords.latitude, 2);
            let y = Math.pow(store.location.lng - position.coords.longitude, 2);
            let h = Math.sqrt(x+y);
            if ( closest.distance>h )
              closest = { store: store, distance: h};
          }
      });

      closest.store.showInfo = true;

      this.setState(() =>  {
        return {center: closest.store.location, zoom: 16, loadingOwnLocation: false};
      });
    }

    render() {
        const createMapOptions = () => {
            return {
                gestureHandling: 'auto',
                draggable: false,
                keyboardShortcuts: false,
                zoomControl: true,
                scrollwheel: false,
                disableDoubleClickZoom: true
            };
        };

        const StoreInfoElement = ({store}) => {
            if(store.showInfo) {
                return <div className="trimmis-map-store-info">
                    <h5>{store.name}</h5>
                    <InfoButton link={'tel://'+store.phone} text={store.phone}/>
                </div>
            } else {
                return <div/>
            }
        };

        const StoreElement = ({ store }) => (
            <div onClick={(e) => this.centerToStore(store,e,false)}>
                <div className="trimmis-map-store-marker"/>
            </div>
        );

        const StoreAndInfo = ({store}) => (
            <span>
                <StoreElement store={store}/>
                <StoreInfoElement className="pull-right" store={store}/>
            </span>
        );

        const styles = {
            height: "300px",
            paddingLeft: 0,
            paddingRight: 0
        };
        const findOwnLocation = this.state.stores.length > 0 ? <div className="col-xs-8 col-xs-offset-2"><Link className="trimmis-map-area-city" to={""} onClick={() => this.getLocation()}>Lähin toimipaikka</Link></div> : <div></div>;
        const waitLocationStyles = {
          fontSize: "20px",
          marginTop: "8px",
          display: this.state.loadingOwnLocation ? "inline-block" : "none"
        };
        const waitLocation = <i className="glyphicon glyphicon-globe animated zoomIn infinite" style={waitLocationStyles}></i>

        return (
        <div className="trimmis-map-area">
        <div className="col-sm-6 trimmis-map-area-cities">
          <h2 className="trimmis-map-area-title">{this.props.title}</h2>
          <div className="row">
              {this.state.stores.map((store, i) => {
                  return <div className="col-sm-4 col-xs-6" key={i}><Link className="trimmis-map-area-city" to={"#"} onClick={(e) => this.centerToStore(store,e, true)}>{store.city.toLowerCase()}</Link></div>
              })}
              {findOwnLocation}{waitLocation}
          </div>
        </div>
        <div className="col-sm-6" style={styles}>
          <GoogleMapReact
              center={this.state.center}
              zoom={this.state.zoom}
              options={createMapOptions}
              bootstrapURLKeys={{key: this.props.apiKey}}
          >
            {this.state.stores.filter(store => store.location).map((store, i) => {
                return <StoreAndInfo store={store} key={i} lat={store.location.lat} lng={store.location.lng} />
          })}
          </GoogleMapReact>
        </div>
        <div className="clearfix"/>
      </div>);
  }

}

export default StoresOnMapViewer;



// WEBPACK FOOTER //
// ../components/StoresOnMapViewer.js